import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function RevealHeading({ lines, className = "", tag = "h1", delayStart = 0, stagger = 0.1 }) {
  const Tag = tag;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={line + i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delayStart + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
